import { mapFiltersToAlgoliaFilters } from '../../shared/data/mappers/mapFiltersToAlgoliaFilters.ts'
import algoliaClient from '../../shared/data/algolia/algolia-client.ts'
import type { ResponseWithFacetsDto } from '../../shared/data/algolia/algolia-base.dto.ts'
import type { VoiceFilters } from '../domain/models/voice-filters.ts'
import type { VoiceDto, VoiceFacets } from './dto/voice.dto.ts'
import { algoliaIndex } from '@/logic/configuration.ts'

export const VoiceService = {
  getVoices: async (
    page: number,
    pageSize: number,
    searchTerm: string | undefined,
    filters: VoiceFilters
  ): Promise<ResponseWithFacetsDto<VoiceDto, VoiceFacets>> => {
    const response = await algoliaClient().searchSingleIndex<VoiceDto>({
      indexName: algoliaIndex.voice,
      searchParams: {
        query: searchTerm ?? '',
        hitsPerPage: pageSize,
        page,
        filters: mapFiltersToAlgoliaFilters({
          accent: filters.accents ?? [],
          language: filters.languages ?? [],
          provider: filters.providers ?? [],
          tags: filters.tags ?? [],
          'meta.technologies': filters.technologies ?? [],
        }),
        analytics: true,
        distinct: true,
        facets: ['accent', 'language', 'tags'],
        maxValuesPerFacet: 200,
      },
    })

    return response as ResponseWithFacetsDto<VoiceDto, VoiceFacets>
  },

  getVoiceByAlias: async (alias: string): Promise<VoiceDto | null> => {
    const response = await algoliaClient().searchSingleIndex<VoiceDto>({
      indexName: algoliaIndex.voice,
      searchParams: {
        query: '',
        filters: `alias:"${alias}"`,
        hitsPerPage: 1,
      },
    })

    return response.hits[0] ?? null
  },
}
